import React from 'react'
import { checkTextTranslation, priceStandardView } from '../../utils/useful'

class TableNumberInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        return (
            <div className="w-100 h-100 flexcc text-center">
                <p className="" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data != null ? priceStandardView(String(this.props.data)) : ' '}</p>
            </div>
        )
    }
}

export default TableNumberInput;